import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { Card } from './card.js';
import { Heading } from './heading.js';
/**
 * Секция-карточка: `Card p-6` + заголовок `Heading level=2 size=sm` + содержимое.
 *
 * До выноса каждый экран держал свою обёртку (`Section` карточки публикации,
 * карточки аккаунтов подписей и сетей правил «Контента», «Автоматика»
 * правил чарджбеков). `Card.Title` кита тут не подходит: это `h3` другого
 * размера, а секции страницы — второй уровень под `PageHeader`.
 */
export function SectionCard({ title, hint, actions, children, className }) {
    const heading = (_jsx(Heading, { level: 2, size: "sm", children: title }));
    const titleBlock = hint != null ? (_jsxs("div", { className: "flex flex-col gap-1", children: [heading, hint] })) : (heading);
    return (_jsxs(Card, { className: cn('flex flex-col gap-3 p-6', className), children: [actions != null ? (_jsxs("div", { className: "flex flex-wrap items-start justify-between gap-3", children: [titleBlock, actions] })) : (titleBlock), children] }));
}
//# sourceMappingURL=section-card.js.map